import { render, staticRenderFns } from "./StatisticsView.vue?vue&type=template&id=8b2c19b2&scoped=true"
import script from "./StatisticsView.vue?vue&type=script&lang=js"
export * from "./StatisticsView.vue?vue&type=script&lang=js"
import style0 from "./StatisticsView.vue?vue&type=style&index=0&id=8b2c19b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2c19b2",
  null
  
)

export default component.exports